import { ApolloError } from "@apollo/client";
import { Fonts, Colors } from "@snapchat/snap-design-system";
import { ErrorIcon } from "@snapchat/snap-design-system-icons";
import { type ReactNode, type FC, useMemo } from "react";
import { Flexbox } from "../../core/components";
import { css } from "@emotion/css";

interface ApiErrorNoticeProps {
    error?: ApolloError;
    children: ReactNode | ReactNode[];
}
export const ApiErrorNotice: FC<ApiErrorNoticeProps> = ({ error, children }) => {
    const message = useMemo(() => {
        if (!error) return "";

        // TODO: UPDATE to use known API errors
        // return orgStatErrors.find(({ code }) => error.message.includes(code))?.message ?? "Please refresh the page.";
        return "Please refresh the page.";
    }, [error]);

    if (!error) return <>{children}</>;

    return (
        <Flexbox flexDirection="column" alignItems="center" justifyContent="center" className={container}>
            <ErrorIcon size={24} fill={Colors.Red.V200} />
            <div className={header}>API Error</div>
            <div className={body}>{message}</div>
        </Flexbox>
    );
};

const header = css`
    ${Fonts.Heading.H700}
    margin: 5px 0;
`;

const body = css`
    ${Fonts.Paragraph.P300}
`;

const container = css`
    height: 220px;
`;
